import { createPlatePlugin } from 'platejs/react'
import type { AnyPlatePlugin } from 'platejs/react'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import {
  ERROR_REPORTING_PLUGIN_KEY,
  withErrorReporting,
} from '~publish/legacy/editor/plugins/error-reporting/withErrorReporting'

export const createErrorReportingPlugin = (): AnyPlatePlugin => {
  // Not returned directly from the arrow function: an explicit return type
  // on the expression itself back-propagates into createPlatePlugin's own
  // generic inference and corrupts it (options/node end up typed against
  // the annotation's defaults instead of the literal passed in).
  const plugin = createPlatePlugin({
    key: ERROR_REPORTING_PLUGIN_KEY,
    extendEditor: ({ editor }) =>
      withErrorReporting(editor as unknown as BufferEditor),
  })
  return plugin
}
